import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

// Быстрый ответ иначе не видно — кажется, что кнопка ничего не сделала.
const MIN_VISIBLE_MS = 400;

/**
 * Обновление списков EXONN по кнопке: перечитывает всё под ключом (список,
 * открытую панель, журнал) и держит «идёт обновление» хотя бы миг.
 */
export const useListRefresh = (queryKey: readonly unknown[]) => {
  const queryClient = useQueryClient();
  const [refreshing, setRefreshing] = useState(false);

  const refresh = async () => {
    const started = Date.now();
    setRefreshing(true);

    try {
      await queryClient.refetchQueries({ queryKey, type: "active" });
    } finally {
      const left = MIN_VISIBLE_MS - (Date.now() - started);
      window.setTimeout(() => setRefreshing(false), Math.max(left, 0));
    }
  };

  return { refreshing, refresh };
};
